import { Badge as MuiBadge, BadgeProps as MuiBadgeProps } from '@mui/material';

export const Badge = ({ ...rest }: MuiBadgeProps) => <MuiBadge {...rest} />;
